/**
 * PDP Variant Swap — self-contained variant handling for Riplee's PDP.
 * v2 — flavour + size gallery filtering
 * v2.1 — highlight icon alt text fix (use hl.label as alt)
 */
(function() {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    var container = document.querySelector('[data-section-type="product-template"]')
      || document.querySelector('.product-section');
    if (!container) return;

    var sectionId = container.getAttribute('data-section-id');
    if (!sectionId) return;

    var dataEl = document.getElementById('pdp-flavour-data-' + sectionId);
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.warn('PDP: Could not parse flavour data', e);
      return;
    }

    var variants = data.variants || [];
    var currencyFormat = data.currency_format || '${{amount}}';
    var highlightsMap = data.highlights || {};
    var ingredientCardsMap = data.ingredient_cards || {};
    var ingredientImagesMap = data.ingredient_images || {};

    function getCurrentOptions() {
      var options = {};
      var selectors = container.querySelectorAll('.single-option-selector');
      selectors.forEach(function(sel) {
        var idx = sel.getAttribute('data-index');
        if (idx) options[idx] = sel.value;
      });
      return options;
    }

    function findVariant(options) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        if (options.option1 && v.option1 !== options.option1) match = false;
        if (options.option2 && v.option2 !== options.option2) match = false;
        if (options.option3 && v.option3 !== options.option3) match = false;
        if (match) return v;
      }
      return null;
    }

    function resolveAndUpdate() {
      var options = getCurrentOptions();
      var variant = findVariant(options);
      if (variant) {
        onVariantChange(variant, sectionId, variants, currencyFormat, container, highlightsMap, ingredientCardsMap, ingredientImagesMap);
      }
    }

    var optionSelectors = container.querySelectorAll('.single-option-selector');
    optionSelectors.forEach(function(sel) {
      sel.addEventListener('change', function() { resolveAndUpdate(); });
    });

    var swatches = container.querySelectorAll('.pdp-hero__swatch, .pdp-hero__pill, .pdp-hero__flavour-pill');
    swatches.forEach(function(swatch) {
      swatch.addEventListener('click', function() {
        var value = this.getAttribute('data-flavour-value');
        var optionIndex = this.getAttribute('data-option-index');
        var selector = container.querySelector('.single-option-selector[data-index="' + optionIndex + '"]');
        if (selector) {
          selector.value = value;
          selector.dispatchEvent(new Event('change', { bubbles: true }));
        }
        swatches.forEach(function(s) {
          s.classList.remove('pdp-hero__swatch--active', 'pdp-hero__pill--active', 'pdp-hero__flavour-pill--active');
          s.setAttribute('aria-pressed', 'false');
        });
        this.classList.add('pdp-hero__swatch--active', 'pdp-hero__pill--active');
        this.setAttribute('aria-pressed', 'true');
      });
    });

    var sizePills = container.querySelectorAll('.pdp-hero__size-pill');
    sizePills.forEach(function(pill) {
      pill.addEventListener('click', function() {
        var value = this.getAttribute('data-size-value');
        var optionIndex = this.getAttribute('data-option-index');
        var selector = container.querySelector('.single-option-selector[data-index="' + optionIndex + '"]');
        if (selector) {
          selector.value = value;
          selector.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var siblings = this.parentElement.querySelectorAll('.pdp-hero__size-pill');
        siblings.forEach(function(s) {
          s.classList.remove('pdp-hero__size-pill--active');
          s.setAttribute('aria-pressed', 'false');
        });
        this.classList.add('pdp-hero__size-pill--active');
        this.setAttribute('aria-pressed', 'true');
      });
    });

    var purchaseTabs = container.querySelectorAll('.pdp-purchase__tab');
    var frequencyRow = document.getElementById('pdp-frequency-' + sectionId);
    var purchaseTypeInput = document.getElementById('pdp-purchase-type-' + sectionId);
    var addBtnTextEl = document.getElementById('pdp-add-btn-text-' + sectionId);
    purchaseTabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var selected = this.getAttribute('data-purchase-tab');
        purchaseTabs.forEach(function(t) {
          var isActive = t.getAttribute('data-purchase-tab') === selected;
          t.classList.toggle('pdp-purchase__tab--active', isActive);
          t.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        if (frequencyRow) frequencyRow.classList.toggle('pdp-purchase__frequency--hidden', selected !== 'subscribe');
        if (purchaseTypeInput) purchaseTypeInput.value = selected;
        if (addBtnTextEl) addBtnTextEl.textContent = selected === 'subscribe' ? 'SUBSCRIBE' : 'ADD TO CART';
      });
    });

    var freqPills = container.querySelectorAll('.pdp-purchase__freq-pill');
    var freqHiddenInput = document.getElementById('pdp-freq-value-' + sectionId);
    freqPills.forEach(function(pill) {
      pill.addEventListener('click', function() {
        freqPills.forEach(function(p) {
          p.classList.remove('pdp-purchase__freq-pill--active');
          p.setAttribute('aria-pressed', 'false');
        });
        this.classList.add('pdp-purchase__freq-pill--active');
        this.setAttribute('aria-pressed', 'true');
        if (freqHiddenInput) freqHiddenInput.value = this.getAttribute('data-freq-value');
      });
    });

    var qtyMinus = container.querySelector('[data-pdp-qty-minus]');
    var qtyPlus = container.querySelector('[data-pdp-qty-plus]');
    var qtyInput = container.querySelector('.pdp-hero__qty-input');
    if (qtyMinus && qtyPlus && qtyInput) {
      qtyMinus.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) qtyInput.value = val - 1;
      });
      qtyPlus.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });
    }

    var lightbox = document.getElementById('pdp-lightbox-' + sectionId);
    var lightboxImg = document.getElementById('pdp-lightbox-img-' + sectionId);
    var lightboxCounter = document.getElementById('pdp-lightbox-counter-' + sectionId);
    var lightboxIndex = 0;

    function getLightboxImages() {
      var imgs = [];
      var mainImg = document.getElementById('pdp-main-img-' + sectionId);
      if (mainImg) imgs.push({ src: mainImg.getAttribute('data-full-src') || mainImg.src, alt: mainImg.alt });
      var secondaryGrid = document.getElementById('pdp-secondary-grid-' + sectionId);
      if (secondaryGrid) {
        secondaryGrid.querySelectorAll('.pdp-hero__secondary-image:not(.pdp-hero__secondary-image--hidden)').forEach(function(item) {
          var img = item.querySelector('img');
          if (img) imgs.push({ src: img.getAttribute('data-full-src') || img.src, alt: img.alt });
        });
      }
      return imgs;
    }

    function openLightbox(index) {
      if (!lightbox || !lightboxImg) return;
      var imgs = getLightboxImages();
      if (!imgs.length) return;
      lightboxIndex = Math.max(0, Math.min(index, imgs.length - 1));
      lightboxImg.src = imgs[lightboxIndex].src;
      lightboxImg.alt = imgs[lightboxIndex].alt;
      if (lightboxCounter) lightboxCounter.textContent = (lightboxIndex + 1) + ' / ' + imgs.length;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function navigateLightbox(dir) {
      var imgs = getLightboxImages();
      if (!imgs.length) return;
      lightboxIndex = (lightboxIndex + dir + imgs.length) % imgs.length;
      lightboxImg.style.opacity = '0';
      setTimeout(function() {
        if (lightboxCounter) lightboxCounter.textContent = (lightboxIndex + 1) + ' / ' + imgs.length;
        var preload = new Image();
        preload.onload = function() {
          lightboxImg.src = imgs[lightboxIndex].src;
          lightboxImg.alt = imgs[lightboxIndex].alt;
          lightboxImg.style.opacity = '1';
        };
        preload.src = imgs[lightboxIndex].src;
      }, 160);
    }

    var galleryEl = document.getElementById('pdp-gallery-' + sectionId);
    if (galleryEl) {
      var mainWrap = document.getElementById('pdp-main-wrap-' + sectionId);
      function handleTriggerClick(trigger) {
        var isMobile = window.innerWidth < 750;
        var mainImg = document.getElementById('pdp-main-img-' + sectionId);
        if (isMobile && trigger !== mainWrap) {
          var img = trigger.querySelector('img');
          if (img && mainImg) {
            var fullSrc = img.getAttribute('data-full-src') || img.src;
            mainImg.style.opacity = '0';
            setTimeout(function() {
              mainImg.src = fullSrc;
              mainImg.srcset = img.getAttribute('data-full-srcset') || '';
              mainImg.alt = img.alt;
              mainImg.style.opacity = '1';
              mainWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }, 150);
          }
          return;
        }
        var idx = 0;
        if (trigger !== mainWrap) {
          var visibleItems = galleryEl.querySelectorAll('.pdp-hero__secondary-image:not(.pdp-hero__secondary-image--hidden)');
          for (var i = 0; i < visibleItems.length; i++) {
            if (visibleItems[i] === trigger || visibleItems[i].contains(trigger)) { idx = i + 1; break; }
          }
        }
        openLightbox(idx);
      }
      galleryEl.querySelectorAll('[data-lightbox-trigger]').forEach(function(trigger) {
        trigger.addEventListener('click', function(e) { e.stopPropagation(); handleTriggerClick(trigger); });
      });
    }

    if (lightbox) {
      lightbox.querySelectorAll('[data-lightbox-close]').forEach(function(el) { el.addEventListener('click', closeLightbox); });
      var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
      var nextBtn = lightbox.querySelector('[data-lightbox-next]');
      if (prevBtn) prevBtn.addEventListener('click', function() { navigateLightbox(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { navigateLightbox(1); });
      document.addEventListener('keydown', function(e) {
        if (lightbox.getAttribute('aria-hidden') !== 'false') return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') navigateLightbox(-1);
        if (e.key === 'ArrowRight') navigateLightbox(1);
      });
    }

    document.querySelectorAll('.pdp-accordion__toggle').forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        var expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !expanded);
      });
    });

    (function populateAccordionOnInit() {
      var initVariant = findVariant(getCurrentOptions());
      if (!initVariant) return;
      var ingredientsEl = document.getElementById('pdp-accordion-ingredients-' + sectionId);
      if (ingredientsEl && initVariant.full_ingredients && !ingredientsEl.textContent.trim())
        ingredientsEl.innerHTML = escapeHtml(initVariant.full_ingredients).replace(/\n/g, '<br>');
      var gaEl = document.getElementById('pdp-accordion-ga-' + sectionId);
      if (gaEl && initVariant.guaranteed_analysis && !gaEl.textContent.trim())
        gaEl.innerHTML = formatGAasTable(initVariant.guaranteed_analysis);
      var feedEl = document.getElementById('pdp-accordion-feeding-' + sectionId);
      if (feedEl && initVariant.feeding_guide && !feedEl.textContent.trim())
        feedEl.innerHTML = escapeHtml(initVariant.feeding_guide).replace(/\n/g, '<br>');
    })();

    (function selectVariantFromUrl() {
      var params = new URLSearchParams(window.location.search);
      var urlVariantId = params.get('variant');
      if (!urlVariantId) return;
      var targetId = parseInt(urlVariantId, 10);
      var target = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === targetId) { target = variants[i]; break; }
      }
      if (!target) return;
      container.querySelectorAll('.single-option-selector').forEach(function(sel) {
        var idx = sel.getAttribute('data-index');
        if (idx && target[idx]) sel.value = target[idx];
      });
      var mainImg = document.getElementById('pdp-main-img-' + sectionId);
      var hasNewImage = mainImg && target.featured_image_url;
      if (hasNewImage) {
        var baseUrl = target.featured_image_url;
        var newSrcset = baseUrl.replace('width=800', 'width=400') + ' 400w, ' + baseUrl.replace('width=800', 'width=600') + ' 600w, ' + baseUrl + ' 800w, ' + baseUrl.replace('width=800', 'width=1000') + ' 1000w';
        var newAlt = (target.featured_image && target.featured_image.alt) ? target.featured_image.alt : mainImg.alt;
        mainImg.style.transition = 'none';
        mainImg.src = baseUrl; mainImg.srcset = newSrcset; mainImg.alt = newAlt;
        var reveal = function() {
          mainImg.style.transition = '';
          document.documentElement.classList.remove('pdp-variant-loading');
          document.documentElement.classList.add('pdp-variant-loaded');
        };
        if (mainImg.complete) reveal(); else { mainImg.onload = reveal; setTimeout(reveal, 2000); }
      }
      onVariantChange(target, sectionId, variants, currencyFormat, container, highlightsMap, ingredientCardsMap, ingredientImagesMap);
      if (!hasNewImage) {
        document.documentElement.classList.remove('pdp-variant-loading');
        document.documentElement.classList.add('pdp-variant-loaded');
      }
    })();

    if (typeof jQuery !== 'undefined') {
      jQuery(container).on('variantChange', function(evt) {
        var variant = evt.variant;
        if (!variant) return;
        var mapped = null;
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].id === variant.id) { mapped = variants[i]; break; }
        }
        if (mapped) onVariantChange(mapped, sectionId, variants, currencyFormat, container, highlightsMap, ingredientCardsMap, ingredientImagesMap);
      });
    }
  }

  function onVariantChange(variant, sectionId, variantData, currencyFormat, container, highlightsMap, ingredientCardsMap, ingredientImagesMap) {
    var el;

    el = document.getElementById('pdp-flavour-name-' + sectionId);
    if (el && variant.option1) el.textContent = variant.option1;

    el = document.getElementById('pdp-pitch-' + sectionId);
    if (el) el.textContent = variant.pitch || '';

    el = document.getElementById('pdp-great-for-' + sectionId);
    if (el) {
      if (variant.great_for) { el.innerHTML = '<strong>Great for</strong> ' + escapeHtml(variant.great_for); el.style.display = ''; }
      else el.style.display = 'none';
    }

    el = document.getElementById('pdp-price-amount-' + sectionId);
    if (el) el.textContent = formatMoney(variant.price, currencyFormat);

    var compareRow = container.querySelector('.pdp-hero__price-compare');
    if (compareRow) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareRow.textContent = formatMoney(variant.compare_at_price, currencyFormat);
        compareRow.style.display = '';
      } else compareRow.style.display = 'none';
    }

    el = document.getElementById('pdp-price-size-' + sectionId);
    if (el && variant.option2) el.textContent = '/ ' + variant.option2;

    var coinsVal = Math.round(variant.price / 100);
    el = document.getElementById('pdp-coins-amount-' + sectionId);
    if (el) el.textContent = coinsVal;
    el = document.getElementById('pdp-coins-amount-sub-' + sectionId);
    if (el) el.textContent = coinsVal;

    var sizePillsContainer = document.getElementById('pdp-size-pills-' + sectionId);
    if (sizePillsContainer) {
      sizePillsContainer.querySelectorAll('.pdp-hero__size-pill-perlb').forEach(function(pEl) {
        var lbs = parseInt(pEl.getAttribute('data-size-lbs'), 10);
        var sizeValue = pEl.closest('.pdp-hero__size-pill').getAttribute('data-size-value');
        if (lbs > 0 && variant.option1) {
          for (var i = 0; i < variantData.length; i++) {
            if (variantData[i].option1 === variant.option1 && variantData[i].option2 === sizeValue) {
              pEl.textContent = '(' + formatMoney(variantData[i].price / lbs, currencyFormat) + '/lb)';
              break;
            }
          }
        }
      });
    }

    el = document.getElementById('pdp-onetime-price-' + sectionId);
    if (el) el.textContent = formatMoney(variant.price, currencyFormat);
    el = document.getElementById('pdp-onetime-size-' + sectionId);
    if (el) el.textContent = variant.option2 ? '/ ' + variant.option2 : '';

    var addBtn = document.getElementById('pdp-add-btn-' + sectionId);
    var addBtnText = document.getElementById('pdp-add-btn-text-' + sectionId);
    if (addBtn && addBtnText) {
      if (variant.available) {
        addBtn.disabled = false;
        addBtnText.textContent = (typeof theme !== 'undefined' && theme.productStrings) ? theme.productStrings.addToCart : 'Add to Cart';
      } else {
        addBtn.disabled = true;
        addBtnText.textContent = (typeof theme !== 'undefined' && theme.productStrings) ? theme.productStrings.soldOut : 'Sold Out';
      }
    }

    el = document.getElementById('pdp-variant-id-' + sectionId);
    if (el) el.value = variant.id;
    el = document.getElementById('ProductSelect-' + sectionId);
    if (el) el.value = variant.id;

    container.querySelectorAll('.pdp-hero__swatch, .pdp-hero__pill, .pdp-hero__flavour-pill').forEach(function(sw) {
      var isActive = sw.getAttribute('data-flavour-value') === variant.option1;
      sw.classList.toggle('pdp-hero__swatch--active', isActive);
      sw.classList.toggle('pdp-hero__pill--active', isActive);
      sw.classList.toggle('pdp-hero__flavour-pill--active', isActive);
      sw.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    var sizeValue = variant.option2 || variant.option1;
    container.querySelectorAll('.pdp-hero__size-pill').forEach(function(pill) {
      var isActive = pill.getAttribute('data-size-value') === sizeValue;
      pill.classList.toggle('pdp-hero__size-pill--active', isActive);
      pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    var mainImg = document.getElementById('pdp-main-img-' + sectionId);
    if (mainImg && variant.featured_image_url) {
      var baseUrl = variant.featured_image_url;
      var newSrcset = baseUrl.replace('width=800', 'width=400') + ' 400w, ' + baseUrl.replace('width=800', 'width=600') + ' 600w, ' + baseUrl + ' 800w, ' + baseUrl.replace('width=800', 'width=1000') + ' 1000w';
      var newAlt = (variant.featured_image && variant.featured_image.alt) ? variant.featured_image.alt : mainImg.alt;
      var preload = new Image();
      preload.srcset = newSrcset;
      preload.src = baseUrl;
      preload.onload = function() {
        mainImg.style.opacity = '0';
        setTimeout(function() { mainImg.src = baseUrl; mainImg.srcset = newSrcset; mainImg.alt = newAlt; mainImg.style.opacity = '1'; }, 120);
      };
      if (preload.complete) { mainImg.src = baseUrl; mainImg.srcset = newSrcset; mainImg.alt = newAlt; }
    }

    var secondaryGrid = document.getElementById('pdp-secondary-grid-' + sectionId);
    if (secondaryGrid) {
      var items = secondaryGrid.querySelectorAll('.pdp-hero__secondary-image');
      var currentFlavour = variant.option1 || '';
      var currentSize = variant.option2 || '';
      items.forEach(function(item) {
        var imgFlavour = item.getAttribute('data-img-flavour') || '';
        var imgSize = item.getAttribute('data-img-size') || '';
        var show = true;
        if (imgFlavour && normalizeForMatch(imgFlavour) !== normalizeForMatch(currentFlavour)) show = false;
        if (show && imgSize && imgSize !== currentSize) show = false;
        var wasHidden = item.classList.contains('pdp-hero__secondary-image--hidden');
        item.classList.toggle('pdp-hero__secondary-image--hidden', !show);
        if (show && wasHidden) {
          item.classList.remove('pdp-hero__secondary-image--fading-in');
          void item.offsetWidth;
          item.classList.add('pdp-hero__secondary-image--fading-in');
        }
      });
    }

    el = document.getElementById('pdp-accordion-ingredients-' + sectionId);
    if (el && variant.full_ingredients) el.innerHTML = escapeHtml(variant.full_ingredients).replace(/\n/g, '<br>');
    el = document.getElementById('pdp-accordion-ga-' + sectionId);
    if (el && variant.guaranteed_analysis) el.innerHTML = formatGAasTable(variant.guaranteed_analysis);
    el = document.getElementById('pdp-accordion-feeding-' + sectionId);
    if (el && variant.feeding_guide) el.innerHTML = escapeHtml(variant.feeding_guide).replace(/\n/g, '<br>');

    // Swap highlights band — KEY FIX: use hl.label as alt text
    if (highlightsMap && variant.option1) {
      var highlights = highlightsMap[variant.option1];
      var hlGrid = document.getElementById('pdp-highlights-grid');
      if (highlights && hlGrid) {
        var hlHtml = '';
        highlights.forEach(function(hl) {
          hlHtml += '<div class="pdp-highlights__item">'
            + '<div class="pdp-highlights__icon">'
            + '<img src="' + escapeHtml(hl.icon) + '" alt="' + escapeHtml(hl.label) + '" width="48" height="48">'
            + '</div>'
            + '<div class="pdp-highlights__label">' + escapeHtml(hl.label) + '</div>'
            + '</div>';
        });
        hlGrid.innerHTML = hlHtml;
      }
    }

    if (ingredientCardsMap && variant.option1) {
      var cards = ingredientCardsMap[variant.option1];
      var cardsList = document.getElementById('pdp-ingredients-grid');
      if (cards && cardsList) {
        var html = '';
        cards.forEach(function(card, idx) {
          html += '<div class="pdp-ingredients__item">'
            + '<div class="pdp-ingredients__item-number">' + (idx + 1) + '</div>'
            + '<div class="pdp-ingredients__item-content">'
            + '<h3 class="pdp-ingredients__name">' + escapeHtml(card.name) + '</h3>'
            + '<p class="pdp-ingredients__desc">' + escapeHtml(card.desc) + '</p>'
            + '</div></div>';
        });
        cardsList.innerHTML = html;
      }
    }

    if (ingredientImagesMap && variant.option1) {
      var imgUrl = ingredientImagesMap[variant.option1];
      var ingredImg = document.getElementById('pdp-ingredients-img');
      if (imgUrl && ingredImg) {
        ingredImg.style.opacity = '0';
        var preloadIngr = new Image();
        preloadIngr.src = imgUrl;
        preloadIngr.onload = function() {
          ingredImg.src = imgUrl;
          ingredImg.srcset = imgUrl.replace('width=800', 'width=400') + ' 400w, ' + imgUrl.replace('width=800', 'width=600') + ' 600w, ' + imgUrl + ' 800w';
          ingredImg.style.opacity = '1';
        };
        if (preloadIngr.complete) { ingredImg.src = imgUrl; ingredImg.style.opacity = '1'; }
      }
    }

    el = document.getElementById('pdp-sticky-price');
    if (el) el.textContent = formatMoney(variant.price, currencyFormat);
    el = document.getElementById('pdp-sticky-flavour');
    if (el && variant.option1) el.textContent = variant.option1;

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({ variant: variant.id }, '', url.toString());
    }
  }

  function initStickyBar() {
    var stickyBar = document.getElementById('pdp-sticky-bar');
    if (!stickyBar) return;
    var showAt = 700, visible = false;
    function checkScroll() {
      var shouldShow = window.scrollY > showAt;
      if (shouldShow !== visible) { visible = shouldShow; stickyBar.classList.toggle('pdp-sticky--visible', visible); }
    }
    window.addEventListener('scroll', throttle(checkScroll, 100), { passive: true });
    var stickyAddBtn = stickyBar.querySelector('.pdp-sticky__add-btn');
    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function() {
        var form = document.getElementById('pdp-add-to-cart-form');
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initStickyBar);
  else initStickyBar();

  function formatMoney(cents, format) {
    var dollars = (cents / 100).toFixed(2);
    return format.replace('{{amount}}', dollars).replace('{{amount_no_decimals}}', Math.round(cents / 100)).replace('{{amount_with_comma_separator}}', dollars.replace('.', ','));
  }
  function formatGAasTable(str) { return str ? escapeHtml(str).replace(/\n/g, '<br>') : ''; }
  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }
  function normalizeForMatch(str) { return (str || '').toLowerCase().replace(/&/g, 'and').replace(/\s+/g, ' ').trim(); }
  function throttle(fn, wait) {
    var last = 0;
    return function() { var now = Date.now(); if (now - last >= wait) { last = now; fn.apply(this, arguments); } };
  }
})();

// AJAX add-to-cart for cross-sell forms
(function() {
  var selectors = '.pdp-hero__also-like-add, .pdp-treats__add-btn';
  document.addEventListener('click', function(e) {
    var btn = e.target.closest(selectors);
    if (!btn) return;
    var form = btn.closest('form');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    btn.disabled = true;
    btn.textContent = 'Adding...';
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function(r) { return r.json(); })
      .then(function() {
        btn.textContent = 'Added!';
        if (typeof jQuery !== 'undefined') jQuery('body').trigger('added.ajaxProduct', jQuery(btn));
        setTimeout(function() { btn.disabled = false; btn.textContent = btn.classList.contains('pdp-treats__add-btn') ? 'Add to Cart' : '+ Add'; }, 1500);
      })
      .catch(function() {
        btn.textContent = 'Error';
        setTimeout(function() { btn.disabled = false; btn.textContent = btn.classList.contains('pdp-treats__add-btn') ? 'Add to Cart' : '+ Add'; }, 1500);
      });
  }, true);
})();
